<div class="card h-200">
  <div class="card-body">
    <div class="row">
      <div class="col d-flex justify-content-between" style="padding:0;">
        <div class="mb-1 text-uppercase col">
          <p [routerLink]="['/repositories', repository.id, 'projects']" (click)="openRepo()">{{ repository.name }}</p>
        </div>
        <div class="dropdown">
          <button type="button" class="btn-actions btn btn-link btn-sm dropdown-toggle" style="margin-top: -5px;"
            id="dropdownMenuRepos" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <i class="fa fa-ellipsis-v mainFontColor" aria-hidden="true"></i>
          </button>
          <div class="dropdown-menu dropdown-menu-lg-left" aria-labelledby="dropdownMenuRepos">
            <button class="dropdown-item border-bottom" type="button" (click)="editRepository(repository)">
              <i class="fa-fw fa fa-edit" aria-hidden="true"></i>
              Editar
            </button>
            <button class="dropdown-item text-gray" type="button" (click)="openDelete(repository)">
              <i class="fa-fw fa fa-trash" aria-hidden="true"></i>
              Excluir
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="mb-1 col">
        <h4>
          {{ repository.description }}
        </h4>
      </div>
    </div>
    <div class="row d-flex col justify-content-end" style="padding:0px;margin:0;">
      <span>
        {{ repository.projects.length }} projeto{{ repository.projects.length === 1 ? '' : 's' }}
      </span>
    </div>
  </div>
</div>